module.exports = __webpack_public_path__ + "static/media/Artboard9.625c70da.png";